import React, { useEffect, useState } from 'react';
import {
  Box,
  CardContent,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { useAppContext } from '../context/AppContext';

function Employment() {
  const { state, actions } = useAppContext();

  const [values, setValues] = useState({
    occupation: state.occupation || '',
    employer:   state.employer   || '',
    dependents: state.dependents || '',
    city:       state.city       || '',
  });

  // showError is true only after the user has tried to leave without filling city.
  // Questionary sets state.employmentNextAttempted = true when Next is clicked on this step.
  const showCityError = state.employmentNextAttempted && !values.city.trim();

  useEffect(() => {
    setValues({
      occupation: state.occupation || '',
      employer:   state.employer   || '',
      dependents: state.dependents || '',
      city:       state.city       || '',
    });
  }, [state.occupation, state.employer, state.dependents, state.city]);

  // Clear the attempt flag when city becomes valid
  useEffect(() => {
    if (state.employmentNextAttempted && values.city.trim()) {
      actions.updateFormData('employmentNextAttempted', false);
    }
  }, [values.city, state.employmentNextAttempted]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (field) => (e) => {
    const val = e.target.value;
    setValues((prev) => ({ ...prev, [field]: val }));
    actions.updateFormData(field, val);
  };

  return (
    <Box>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
          Other Details
        </Typography>

        {/* Occupation */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            Current Occupation
          </Typography>
          <FormControl fullWidth>
            <Select
              value={values.occupation || 'Select Occupation'}
              onChange={handleChange('occupation')}
              displayEmpty
              inputProps={{ 'aria-label': 'Occupation' }}
            >
              <MenuItem value="Select Occupation">
                <em>Select Occupation</em>
              </MenuItem>
              <MenuItem value="salaried">Salaried</MenuItem>
              <MenuItem value="Business">Business / Self-Employed</MenuItem>
              <MenuItem value="Retired">Retired</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Company Name */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            Company Name
          </Typography>
          <TextField
            value={values.employer}
            onChange={handleChange('employer')}
            fullWidth
            placeholder="Company Name"
          />
        </Box>

        {/* Dependents */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            Number of Financial Dependents
          </Typography>
          <TextField
            value={values.dependents}
            onChange={handleChange('dependents')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder="Children + Spouse + Parents + others"
          />
        </Box>

        {/* City — mandatory */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            City <span style={{ color: 'red' }}>*</span>
          </Typography>
          <TextField
            value={values.city}
            onChange={handleChange('city')}
            fullWidth
            placeholder="Your city"
            error={showCityError}
            helperText={showCityError ? 'City is a required field' : ''}
          />
        </Box>
      </CardContent>
    </Box>
  );
}

export default Employment;